<template>
    <rkm-row>
        <rkm-col cols="3">
            <rkm-form-input
                :validations="validations.numero"
                label="Número"
                v-model="model.documentos.carteiraIdentidade.numero"
                uppercase
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-select
                :options="form.estados"
                label="UF"
                text-field="uf"
                v-model="model.documentos.carteiraIdentidade.estadoId"
                value-field="id"
                :validations="validations.estado"
                :disabled="!model.documentos.carteiraIdentidade.numero"
                show-default-option
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-input
                :validations="validations.orgaoEmissor"
                label="Orgão emissor"
                v-model="model.documentos.carteiraIdentidade.orgaoEmissor"
                :disabled="!model.documentos.carteiraIdentidade.numero"
                uppercase
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-date-picker
                :validations="validations.dataEmissao"
                label="Data de emissão"
                v-model="model.documentos.carteiraIdentidade.dataEmissao"
                :disabled="!model.documentos.carteiraIdentidade.numero"
                :min-date="getDataNascimentoString()"
                :max-date="dataAtual"
                right
            />
        </rkm-col>
    </rkm-row>
</template>

<script>
// Moment.
import moment from 'moment'

export default {
    props: {
        dataAtual: { type: String, required: true },
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    computed: {
        validations() {

            return {
                numero: {
                    min: 6,
                    max: 15,
                },
                estado: {},
                orgaoEmissor: {
                    min: 5,
                    max: 8,
                },
                dataEmissao: {},
            }
        }
    },
    watch: {
        'model.documentos.carteiraIdentidade.numero': function (numero) {

            if (!numero) {

                this.model.documentos.carteiraIdentidade.estadoId = null
                this.model.documentos.carteiraIdentidade.orgaoEmissor = ''
                this.model.documentos.carteiraIdentidade.dataEmissao = null
            }
        }
    },
    methods: {
        getDataNascimentoString() {

            return this.model.dataNascimento
                ? moment(this.model.dataNascimento).format('DD/MM/YYYY')
                : null
        },
    },
}
</script>